import { call, put, takeEvery } from 'redux-saga/effects';
import { IProgramGroup, ProgramActionKeys, programsActionCreators, UpdateProgramGroup } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import * as api from '../programsApi';

function* updateProgramGroupSaga(action: UpdateProgramGroup) {
  yield put(uiActionCreators.showSpinnerDialog());
  const response: IApiExecuteRespone<IProgramGroup> = yield call(api.updateProgramGroup, action.payload);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(programsActionCreators.setProgramGroups([response.value]));
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateProgramGroup() {
  yield takeEvery(ProgramActionKeys.UPDATE_PROGRAM_GROUP, updateProgramGroupSaga);
}
